import { useContext } from 'react';
import { YandexMapsApiContext } from './YandexMapsApiProvider';

/**
 * Хук использования контектса
 */
export const useYandexMapsApi = () => useContext(YandexMapsApiContext);
